import React, { useState, useEffect } from "react";
import { Tabs, Card, Avatar, Typography, List } from "antd";
import { Bell, BellDot } from "lucide-react";
import {
  bp_get_batch_notification_for_employee,
  get_ingredient_value_alert,
  get_notification_for_recipe_approval_action,

} from '@/utils/api';
import { useNavigate } from "react-router";
import { defaultColors } from '@/themes/antd-theme';

const { Paragraph } = Typography;

// ==============================|| NOTIFICATION PAGE ||============================== //

const deviation_color = (per) => {
  let color;
  let bg_color;

  switch (true) {
    case per >= 0 && per <= 5:
      color = defaultColors.success;
      bg_color = defaultColors.palette.green[50];
      break;
    case (per >= -10 && per < 0) || (per > 5 && per <= 50):
      color = defaultColors.warning;
      bg_color = defaultColors.palette.amber[50];
      break;
    case per < -10 || per > 50:
      color = defaultColors.error;
      bg_color = defaultColors.palette.red[50];
      break;
    default:
      color = defaultColors.palette.gray[900];
      bg_color = defaultColors.palette.gray[50];
  }
  return { color: color, bg_color: bg_color };
};

const NotificationPage = () => {
  const [notifications_data, set_notifications_data] = useState([]);
  const [alert_data, set_alert_data] = useState([]);

  const success_get_notification = (res) => {
    set_notifications_data(res.data.data);
  };

  const success_get_alerts = (res) => {
    set_alert_data(res.data.data);
  };

  useEffect(() => {
    bp_get_batch_notification_for_employee(success_get_notification);
    get_notification_for_recipe_approval_action(success_get_notification);
  }, []);

  const [activeKey, set_activeKey] = useState("notify");

  const items = [
    {
      key: "notify",
      label: (
        <div className="flex items-center gap-2">
          <span>Notifications</span>
          <Bell
            size={20}
            style={{ color: defaultColors.success }}
          />
        </div>
      ),
      children: (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 p-2">
          {notifications_data?.map((item, index) => (
            <Card key={index} className="hover:shadow-md transition-shadow">
              <div className="flex gap-3">
                <Avatar
                  size={36}
                  style={{
                    color: defaultColors.success,
                    backgroundColor: defaultColors.palette.green[50],
                  }}
                >
                  {item.recipe_name
                    .split(" ")
                    .map((item) => item[0])
                    .join("")
                    .toUpperCase()}
                </Avatar>
                <div className="flex-1">
                  <h6 className="text-base font-semibold m-0 mb-2">{item.msg}</h6>

                  <div className="grid grid-cols-2 gap-1 text-xs">
                    <span className="text-gray-600 dark:text-gray-400">Recipe:</span>
                    <span className="text-gray-900 dark:text-gray-100 truncate">
                      {item?.recipe_name}
                    </span>

                    <span className="text-gray-600 dark:text-gray-400">Batch Number:</span>
                    <span className="text-gray-900 dark:text-gray-100 truncate">
                      {item?.batch_number}
                    </span>

                    <span className="text-gray-600 dark:text-gray-400">Process Name:</span>
                    <span className="text-gray-900 dark:text-gray-100 truncate">
                      {item?.process_name}
                    </span>

                    <span className="text-gray-600 dark:text-gray-400">Schedule Time:</span>
                    <span className="text-gray-900 dark:text-gray-100 truncate">
                      {item?.batch_schedule_time?.slice(0, 19)}
                    </span>
                  </div>
                </div>
              </div>
            </Card>
          ))}
        </div>
      ),
    },
    {
      key: "alert",
      label: (
        <div className="flex items-center gap-2">
          <span>Approval Notifications</span>
          <BellDot
            size={20}
            style={{ color: defaultColors.warning }}
          />
        </div>
      ),
      children: (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 p-2">
          {alert_data?.map((item, index) => (
            <Card key={index} className="hover:shadow-md transition-shadow">
              <div className="flex gap-3">
                <Avatar
                  size={36}
                  style={{
                    color: defaultColors.warning,
                    backgroundColor: defaultColors.palette.amber[50],
                  }}
                >
                  {item.recipe_name
                    .split(" ")
                    .map((item) => item[0])
                    .join("")
                    .toUpperCase()}
                </Avatar>
                <div className="flex-1">
                  <Paragraph
                    ellipsis={{
                      rows: 2,
                      expandable: true,
                      symbol: "more",
                    }}
                    className="text-sm font-medium mb-2"
                  >
                    {item?.msg}
                  </Paragraph>

                  <div className="flex flex-col gap-1 text-xs">
                    <div className="text-gray-600 dark:text-gray-400">
                      Date: {item?.date?.slice(0, 19)}
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          ))}
        </div>
      ),
    },
  ];

  return (
    <Tabs
      activeKey={activeKey}
      onChange={(value) => {
        set_activeKey(value);
        !alert_data?.length &&
          value === "alert" &&
          get_notification_for_recipe_approval_action(success_get_alerts);
      }}
      items={items}
    />
  );
};

export default NotificationPage;
